if (!customElements.get('mobile-fixed-ctas')) {
  class MobileFixedCtas extends HTMLElement {
    constructor() {
      super();

      this.isTicking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handleSectionDeselect = this.handleSectionDeselect.bind(this);
    }

    connectedCallback() {
      this.updateVisibility();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:section:select', this.handleSectionSelect);
      document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
    }

    handleScroll() {
      if (this.isTicking) return;

      this.isTicking = true;
      window.requestAnimationFrame(() => {
        this.updateVisibility();
        this.isTicking = false;
      });
    }

    handleResize() {
      this.updateVisibility();
    }

    handleSectionSelect(evt) {
      if (evt.target && evt.target.contains(this)) {
        this.style.display = 'block';
        this.classList.add('is-editor-visible');
      }
    }

    handleSectionDeselect(evt) {
      if (evt.target && evt.target.contains(this)) {
        this.style.display = '';
        this.classList.remove('is-editor-visible');
        this.updateVisibility();
      }
    }

    updateVisibility() {
      const pastFirstViewport = window.scrollY > window.innerHeight;
      const nearPageBottom = window.scrollY + window.innerHeight + this.offsetHeight + 24 >= document.body.scrollHeight;

      this.classList.toggle('is-visible', pastFirstViewport && !nearPageBottom);
    }
  }

  customElements.define('mobile-fixed-ctas', MobileFixedCtas);
}
